import { NgIf } from '@angular/common';
import { Component, InjectionToken, computed, inject, signal } from '@angular/core';
import { GenericStorageService } from 'src/app/services/storage/generic-storage.service';
import { RawCountrySpecificSetting } from 'src/app/state-management/types/configuration.type';
import { environment } from 'src/environments/environment';
import { OEEnvironment } from 'src/environments/environment.type';
import { MOCKED_COUNTRY_SPECIFIC_SETTINGS } from '../mocks/configuration.service.mock';

export interface MockStorage {
	mockMode: boolean;
	values: RawCountrySpecificSetting[];
}

export const MOCK_STORAGE = new InjectionToken<GenericStorageService<MockStorage>>('MOCK_STORAGE');

@Component({
	selector: 'app-mock-switch',
	templateUrl: './mock-switch.component.html',
	imports: [NgIf],
})
export class MockSwitchComponent {
	private mockStorage = inject(MOCK_STORAGE);
	mockMode = this.mockStorage.value()?.mockMode;
	hovered = signal(false);
	isDev = environment.appMeta.env === OEEnvironment.DEV;
	mockModeButtonLabel = computed(() => {
		if (this.mockMode && this.hovered()) {
			return 'Live Mode';
		} else if (!this.mockMode && !this.hovered()) {
			return 'Live Mode';
		} else {
			return 'Mock Mode';
		}
	});

	toggleMockMode() {
		const currVal = this.mockStorage.value();
		if (currVal) {
			let updatedValues = [...MOCKED_COUNTRY_SPECIFIC_SETTINGS];

			if (currVal.values) {
				currVal.values.forEach((changedSetting) => {
					const baseSetting = updatedValues.find(
						(baseSetting) => baseSetting.name === changedSetting.name,
					);
					if (baseSetting) {
						baseSetting.value = changedSetting.value;
					}
				});
			}

			this.mockStorage.setValue({
				mockMode: !currVal.mockMode,
				values: updatedValues,
			});
			window.location.reload();
		}
	}
}
